// eslint-disable-next-line import/prefer-default-export
export const projectLogColorMapping = {
  new: 'var(--blue-500)',
  update: 'var(--orange-500)',
  submit: 'var(--green-500)',

  // Project status
  liquidation: 'var(--orange-500)',
};
